var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"timeout":6000,"top":"","right":"","color":_vm.$store.state.alerts.color},model:{value:(_vm.$store.state.alerts.isOpen),callback:function ($$v) {_vm.$set(_vm.$store.state.alerts, "isOpen", $$v)},expression:"$store.state.alerts.isOpen"}},[_vm._v("\n  "+_vm._s(_vm.$store.state.alerts.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }